module.exports = __webpack_public_path__ + "static/tree-01-c70fbb988a50ff89c2f192ee282b5132.png";